export default __webpack_public_path__ + "static/media/badge_2.5f703cd5.png";